import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of, switchMap, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import Swal from 'sweetalert2';
import { AuthUtilService } from '../common/auth-util.service';
import { UrlUtilService } from '../common/url-util.service';
import { AccountService } from 'src/app/api/auth/services/account/account.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
    private urlUtil: UrlUtilService,
    private route: ActivatedRoute,
    private accountService: AccountService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this._check(redirectUrl);
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this._check(redirectUrl, childRoute);
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._check('/');
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Check the authenticated status
   *
   * @param redirectURL
   * @private
   */
  private _check(
    redirectURL: string,
    route?: ActivatedRouteSnapshot
  ): Observable<boolean> {
    // if (!environment.requireAuthen) {
    //   return of(true);
    // }
    // check auth by role
    // console.log('redirectURL', redirectURL);
    if (!!route) {
      let orderNo = this.urlUtil.getUrlParamAuthGuard(
        route!,
        redirectURL,
        'orderNo'
      );
      // console.log(redirectURL, 'orderNo', orderNo);
    }

    if (
      environment.manageAuth.pageAuth &&
      redirectURL != '/' &&
      redirectURL != '/home' &&
      (this.authService.userRole ?? []).length
    ) {
      let authRequired = environment.manageAuth.pageAuth.filter((item) =>
        redirectURL.startsWith(item.route)
      );
      // const userRoles = this.authService.getUserRole();
      const userRoles = this.authService.userRole ?? [];
      if (authRequired.length > 0) {
        let found = false;

        for (let i = 0; i < authRequired.length; i++) {
          found = userRoles.some((item) => authRequired[i].auth.includes(item));
          // for (let authLoop = 0; authLoop < authRequired[i].auth.length; authLoop++) {
          //   // found = userRoles.roles.some(
          //   //   (item) => item.roleName == authRequired[i].auth[authLoop]
          //   // );
          //   found = userRoles.some(
          //     (item) => item === authRequired[i].auth[authLoop]
          //   );
          //   if (found) {
          //     break;
          //   }
          // }
          if (found) {
            break;
          }
        }
        if (!found) {
          Swal.fire({
            icon: 'error',
            title: 'Unauthorized',
            // text: 'You have no authority to access ' + redirectURL,
            html: 'No Authorize, Please contact <br>Sales Representative or Customer Service.',
          });

          // Redirect to home
          this.router.navigate(['/home']);

          // Prevent the access
          return of(false);
        }
      }
    }
    // Check the authentication status
    return this.authService.check().pipe(
      switchMap((authenticated) => {
        // If the user is not authenticated...
        if (!authenticated) {
          // Redirect to the sign-in page
          if (
            !!this.authService.appToken &&
            AuthUtilService.isTokenExpired(this.authService.appToken)
          ) {
            this.authService.signOut();
            Swal.fire({
              icon: 'error',
              title: 'Session Expired!',
              text: 'Please sign in again.',
            }).then(() => {
              this.router.navigate(['sign-in'], {
                queryParams: { redirectURL },
              });
            });
          } else {
            this.authService.signOut();
            this.router.navigate(['sign-in'], { queryParams: { redirectURL } });
          }

          // Prevent the access
          return of(false);
        }

        // Allow the access
        if (
          // environment.requireAuthen &&
          // environment.manageAuth.pageAuth &&
          redirectURL != '/' &&
          // redirectURL != '/home' &&
          !!this.authService.accessToken &&
          !!this.authService.appToken &&
          !!this.authService.appTokenApi
        ) {
          return this.accountService.getIsActive().pipe(
            switchMap((res) => {
              if (res.data) {
                return of(true);
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error!',
                  text: res.message,
                }).then(() => {
                  this.authService.signOut();
                  this.router.navigate(['sign-in'], {
                    queryParams: { redirectURL },
                  });
                });
                return of(false);
              }
            }),
            catchError(() => of(false))
          );
        }
        return of(true);
      })
    );
  }
}
